import { render, staticRenderFns } from "./IssueTable.vue?vue&type=template&id=8f9134ac&scoped=true&"
import script from "./IssueTable.vue?vue&type=script&lang=js&"
export * from "./IssueTable.vue?vue&type=script&lang=js&"
import style0 from "./IssueTable.vue?vue&type=style&index=0&id=8f9134ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9134ac",
  null
  
)

export default component.exports